import React, { useCallback } from 'react';
import QuantityEditModal from '~/app/common/QuantityEditModal';
import useTranslation from '~/app/hooks/useTranslation';
import { Material } from '~/types';
import { isVariousMaterial } from '../helper';

export interface QuantityEditFormProps {
  open: boolean
  onClose: () => void
  material?: Material
  onSave: (material: Material, quantity: number) => void
}

export type QuantityEditFormComponent = React.FC<QuantityEditFormProps>

const QuantityEditForm: QuantityEditFormComponent = ({ open, onClose, material, onSave }) => {
  const { t } = useTranslation('parts');

  const displayName = material && isVariousMaterial(material)
    ? t('variousMaterial')
    : (material?.name ?? '');

  const handleSave = useCallback((quantity: number) => {
    if (!material) {
      return;
    }
    onSave(material, quantity);
  }, [material, onSave]);

  return (
    <QuantityEditModal
      open={open}
      onClose={onClose}
      name={displayName}
      quantity={material?.quantity ?? 1}
      onSave={handleSave}
    />
  );
};

export default QuantityEditForm;
